function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Radio } from '@domain-group/fe-blueprint-ui/form';
import * as styles from './radio-group.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var RadioGroup = _ref => {
  var options = _ref.options,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? () => {} : _ref$onChange,
    currentValue = _ref.currentValue;
  var _useState = useState(currentValue),
    _useState2 = _slicedToArray(_useState, 2),
    selectedValue = _useState2[0],
    setSelectedValue = _useState2[1];
  useEffect(() => {
    setSelectedValue(currentValue);
  }, [currentValue]);
  return ___EmotionJSX("ul", {
    css: styles.container
  }, options.map(option => ___EmotionJSX("li", {
    key: option.value
  }, ___EmotionJSX(Radio, {
    name: option.value,
    id: option.value,
    checked: selectedValue === option.value,
    labelContent: option.label,
    onChange: () => {
      setSelectedValue(option.value);
      _onChange === null || _onChange === void 0 ? void 0 : _onChange(option.value);
    }
  }))));
};